import { DefaultDiagramState } from 'primary/Diagram/DefaultDiagramState';
import FixForLinkAction from 'primary/Diagram/FixForLinkAction';

import CustomDeleteAction from './CustomDeleteAction';
import CustomZoomAction from './CustomZoomAction';
import { LinkFactory } from './Link';
import { NodeFactory } from './Node';
import { PortFactory } from './Port';

import createEngine, { DiagramModel } from '@projectstorm/react-diagrams';

export default class Diagram {
  activeModel;
  diagramEngine;

  constructor(ToastsStore) {
    this.ToastsStore = ToastsStore
    this.diagramEngine = createEngine({
      registerDefaultDeleteItemsAction: false,
      registerDefaultZoomCanvasAction: false,
    });
    this.diagramEngine.getStateMachine().pushState(new DefaultDiagramState());
    this.diagramEngine.getNodeFactories().registerFactory(new NodeFactory());
    this.diagramEngine.getPortFactories().registerFactory(new PortFactory());
    this.diagramEngine.getLinkFactories().registerFactory(new LinkFactory());
    this.diagramEngine
      .getActionEventBus()
      .registerAction(new CustomDeleteAction({}, ToastsStore));
    this.diagramEngine
      .getActionEventBus()
      .registerAction(new CustomZoomAction());
    this.diagramEngine
      .getActionEventBus()
      .registerAction(new FixForLinkAction());
    this.newModel();
  }

  newModel() {
    this.activeModel = new DiagramModel();
    this.activeModel.setGridSize(64);
    this.activeModel.setOffset(100, 100);
    this.diagramEngine.setModel(this.activeModel);
  }

  getActiveModel = () => this.activeModel;

  getDiagramEngine = () => this.diagramEngine;

  addNode = node => {
    this.activeModel.addNode(node);
  };
}
